import { createSlice } from '@reduxjs/toolkit';
import { TokenInfo } from '../../models';
import { clearLocalStorage, persistLocalStorage } from '../../utilities/localStorage.utility';
import { Status } from '../../types/user';
import axios from 'axios';

export const TokenKey = 'token';

export const EmptyTokenState: TokenInfo = {
    status: Status.notAuthenticated,
    token: null,
};

function loadInitialTokenState(): TokenInfo {
    const raw = localStorage.getItem(TokenKey);
    if (!raw) {
        axios.defaults.headers.common['Authorization'] = '';
        return EmptyTokenState;
    }

    // Soporta dos formatos:
    // 1) JSON: {"status":1,"token":"..."}
    // 2) legacy string: "<jwt>"
    try {
        const parsed = JSON.parse(raw) as Partial<TokenInfo>;
        const token = typeof parsed.token === 'string' ? parsed.token : null;
        const status = token ? (parsed.status ?? Status.authenticated) : Status.notAuthenticated;
        axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : '';
        return { status, token };
    } catch {
        axios.defaults.headers.common['Authorization'] = `Bearer ${raw}`;
        return { status: Status.authenticated, token: raw };
    }
}



export const tokenSlice = createSlice({
    name: TokenKey,
    initialState: loadInitialTokenState(),
    reducers: {
      createToken: (state, action) => {
        const newState = { ...action.payload, status: Status.authenticated }; // Modificación aquí
        persistLocalStorage<TokenInfo>(TokenKey, newState);
        axios.defaults.headers.common['Authorization'] =
          newState.token ? `Bearer ${newState.token}` : '';
        return newState;
      },
      updateToken: (state, action) => {
        const newState = { ...state, ...action.payload, status: Status.authenticated }; // Modificación aquí
        persistLocalStorage<TokenInfo>(TokenKey, newState);
        axios.defaults.headers.common['Authorization'] =
          newState.token ? `Bearer ${newState.token}` : '';
        return newState;
      },
      resetToken: () => {
        clearLocalStorage(TokenKey);
        axios.defaults.headers.common['Authorization'] = '';
        return EmptyTokenState;
      },
    },
  });
  

export const { createToken, updateToken, resetToken } = tokenSlice.actions;

export default tokenSlice.reducer;
